import { render } from "./ArrowRight.vue?vue&type=template&id=3db38a81"
const script = {}

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__